import React from "react";
import classNames from "classnames";
import { GanttFilter } from "@planzone/dto";
import { useTranslation } from "react-i18next";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { Checkbox } from "@common/checkbox";

import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";

const options = ["list", "task", "completedWork"];

function DataTypeFilter({ dataTypes, select }: Props) {
  const { t } = useTranslation();
  const isSelected = (type: string) =>
    !!dataTypes && !!dataTypes.find((dataType) => dataType === type);

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={classNames(styles.dataTypeFilter, {
            [styles.opened]: isVisible,
          })}
        >
          <div className={styles.input} onClick={isVisible ? hide : show}>
            {dataTypes && dataTypes.length > 0 ? (
              <p className={styles.selectedDataTypes}>
                {dataTypes.map((type, index) => (
                  <span key={type}>
                    {t(`projectPage.listsPage.filters.dataType.${type}`)}
                    {index !== dataTypes.length - 1 ? ", " : ""}
                  </span>
                ))}
              </p>
            ) : (
              <p className={styles.placeholder}>
                {t("projectPage.listsPage.filters.show")}
              </p>
            )}
            <ToggleArrow className={styles.toggleArrow} />
          </div>
          {isVisible && (
            <div className={styles.list}>
              {options.map((option) => (
                <div
                  key={option}
                  className={styles.item}
                  onClick={() =>
                    select(
                      (isSelected(option)
                        ? Array.isArray(dataTypes)
                          ? dataTypes.filter((type) => type !== option)
                          : []
                        : [
                            ...(dataTypes || []),
                            option,
                          ]) as GanttFilter["elementTypes"],
                    )
                  }
                >
                  <Checkbox isChecked={isSelected(option)} />
                  <p className={styles.typeName}>
                    {t(`projectPage.listsPage.filters.dataType.${option}`)}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { DataTypeFilter };
